import { createStore } from 'jotai'

export const tenantStore = createStore()
